<section class="onboard-servey">
<div class="d-md-flex justify-content-between ">
    <div class="servey-img">
        <img src="assets/images/servey-img.jpg" alt="image"/>
    </div>
    <div class="servey-detail d-flex align-items-center text-center text-md-left" *ngIf="displaySection == 1">
        <div>
            <span class="sub-title">Welcome!</span>
            <h2 class="servey-title">Let's Find What Moves You</h2>
            <p class="servey-desc">Answer a few questions to help us personalize your
                class recommendations.</p>
            <div class="btns-wrap">
                <a (click)="displaySection = 2;moveToTop()" class="btn">Take Survey</a>
                <a href="#" class="btn skip-btn"><span>Skip For Now</span></a>
            </div>
        </div>
    </div>
    <div class="servey-detail d-flex align-items-center text-center text-md-left d-none" *ngIf="displaySection == 2">
        <form [formGroup]="formGroupOne">
            <span class="sub-title">Step 1 of 4</span>
            <h2 class="servey-title">General</h2>
            <div class="form-group text-left">
                <label class="txt-label">DOB:</label>
                <mat-form-field class="example-full-width" appearance="fill" style="background: white;">
                    <input matInput readonly [matDatepicker]="picker" formControlName="dob" (dateChange)="selectedMonthSelected($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
            </div>
            <div class="form-group text-left">
                <label class="txt-label" for="country">Country</label>
                <select class="form-control" name="country" id="country" formControlName="country" >
                    <option *ngFor="let i of surveyData?.countries" value="{{ i.id }}" >{{ i.name }}</option>
                </select>
            </div>
            <div class="form-group text-left" >
                <label class="txt-label" for="state">State</label>
                <select class="form-control" name="state" id="state" formControlName="state">
                    <option *ngFor="let i of surveyData?.states" value="{{ i.id }}" >{{ i.name }}</option>
                </select>
            </div>
            <div class="form-group text-left">
                <input class="form-check-input" type="radio" id="male" name="gender" value="male" formControlName="gender">
                <label class="form-check-lbl" for="male">Male</label><br>
            </div>
            <div class="form-group text-left">
                <input class="form-check-input" type="radio" id="female" name="gender" value="female" formControlName="gender">
                <label class="form-check-lbl" for="female">Female</label><br>
            </div>
            <div class="form-group text-left">
                <input class="form-check-input" type="radio" id="other" name="gender" value="other" formControlName="gender">
                <label class="form-check-lbl" for="other">Other</label>
            </div>
            
            <div class="divider-div"></div>
            <h2 class="servey-title">Rank the service based on your experience ?</h2>
            <div class="feature-list ">
                <div cdkDropList #personList = "cdkDropList" *ngIf="surveyData?.mappings?.PLATFORMS"
                        [cdkDropListData] = "surveyData?.mappings?.PLATFORMS" [cdkDropListConnectedTo] = "[servicesList]"
                        class = "d-flex justify-content-between flex-wrap example-list" (cdkDropListDropped) = "onDrop($event)" >
                <div *ngFor = "let item of surveyData?.mappings?.PLATFORMS;let i = index" class = "feature-item divlayout" cdkDrag>
                    <span style="color: black;">
                         {{i+1}} 
                    </span>
                    {{item.value}} 
                    <em class="drag-point">
                        <span>..</span>
                        <span>..</span>
                        <span>..</span>
                    </em>
                </div>
                </div>
            </div>
            <p class="drag-drop-desc">( Please drag and drop boxes to rank. )</p>
            <div class="btns-wrap text-center">
                <a (click)="formGroupOneValidThenOnlyMoveForward()" class="btn">Next Question</a>
            </div>
        </form>
    </div>
    <div class="servey-detail d-flex align-items-center text-center text-md-left d-none" *ngIf="displaySection == 3">
        <form [formGroup]="formGroupTwo">
            <span class="sub-title">Step 2 of 4</span>
            <h2 class="servey-title">Live Well</h2>
            
            <h2 class="servey-title">Check all areas of interest </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap" >
                <div class="feature-item" *ngFor="let i of surveyData.mappings.DIGITAL.PRODUCTS | keyvalue">
                    <input type="checkbox" id="{{i.key}}" >
                    <label class="form-check-label questions" for="{{i.key}}" (click)="questionSelectionSecondSectionInterest(i.key)" [style.background]="(this.formGroupTwo.value.checkAllAreasOfInterest?.includes(i?.key)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupTwo.value.checkAllAreasOfInterest?.includes(i?.key)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.value}} </strong>
                    </label>
                </div>  
            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Goals </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.mappings.DIGITAL.GOALS | keyvalue">
                    <input type="checkbox" id="{{i.key}}" >
                    <label class="questions" for="{{i.key}}" (click)="questionSelectionSecondSectionGoals(i.key)" [style.background]="(this.formGroupTwo.value.goals?.includes(i?.key)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupTwo.value.goals?.includes(i?.key)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.value}} </strong>
                    </label>
                </div>
                <div class="feature-item">
                    <input class="specify-input" type="text" id="pleasespecify" placeholder="Other please specify" formControlName="questionSecondSectionGoalsOther">
                </div>
                <div class="feature-item d-none d-md-block">&nbsp;</div>
                
            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Categories of interest </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.category?.digital">
                    <input type="checkbox" id="{{i._id}}" >
                    <label class="questions" for="{{i._id}}" (click)="questionSelectionSecondSectionCategoriesOfInterest(i._id)" [style.background]="(this.formGroupTwo.value.categoriesOfInterest?.includes(i?._id)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupTwo.value.categoriesOfInterest?.includes(i?._id)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.name}} </strong>
                    </label>
                </div>
                <div class="feature-item">
                    <input class="specify-input" type="text" placeholder="Other please specify" formControlName="otherInSecondQuestionCategoriesOfInterest">
                </div>
            </div>

            <div class="btns-wrap text-center">
                <a (click)="nextQuestionClickedOnSecondQuestionSection()" class="btn">Next Question</a>
            </div>
        </form>
    </div>

    <div class="servey-detail d-flex align-items-center text-center text-md-left d-none" *ngIf="displaySection == 4">
        <form [formGroup]="formGroupThird">
            <span class="sub-title">Step 3 of 4</span>
            <h2 class="servey-title">Travel well</h2>
            
            <h2 class="servey-title">Check all areas of interest </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.mappings?.TRAVEL?.PRODUCTS | keyvalue">
                    <input type="checkbox" id="{{i.key}}" >
                    <label class="questions" for="{{i.key}}" (click)="thirdSectioncheckAllAreasOfInterest(i.key)" [style.background]="(this.formGroupThird.value.checkAllAreasOfInterest?.includes(i?.key)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupThird.value.checkAllAreasOfInterest?.includes(i?.key)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.value}} </strong>
                    </label>
                </div>
            
                
            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Travel type interested in </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.mappings?.TRAVEL?.TRAVEL_TYPE | keyvalue">
                    <input type="checkbox" id="{{i.key}}" >
                    <label class="questions" for="{{i.key}}" (click)="thirdSectionTravelTypeInterestedIn(i.key)" [style.background]="(this.formGroupThird.value.travelTypeInterestedIn?.includes(i?.key)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupThird.value.travelTypeInterestedIn?.includes(i?.key)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.value}} </strong>
                    </label>
                </div>   
            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Travel style interested in </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.mappings?.TRAVEL?.TRAVEL_STYLE | keyvalue">
                    <input type="checkbox" id="{{i.key}}" >
                    <label class="questions" for="{{i.key}}" (click)="thirdSectionTravelStyleInterestedIn(i.key)" [style.background]="(this.formGroupThird.value.travelStyleInterestedIn?.includes(i?.key)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupThird.value.travelStyleInterestedIn?.includes(i?.key)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.value}} </strong>
                    </label>
                </div> 
            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Top 3 locations of interest (USA) </h2>
            <div class="feature-list d-flex justify-content-between">
                <div class="form-group location-usa d-md-flex justify-content-between">
                    <select class="form-control" name="state1" id="topThreeLocationOfInterestInUsaFieldFirstId" formControlName="topThreeLocationOfInterestInUsaFieldFirst">
                        <option *ngFor="let i of surveyData?.states" [value]="i?.id" >
                            {{ i?.name }}
                        </option>
                    </select>
                    <select class="form-control" name="state2" formControlName="topThreeLocationOfInterestInUsaFieldSecond" id="topThreeLocationOfInterestInUsaFieldSecondId">
                        <option *ngFor="let i of surveyData?.states" value="{{ i.id }}" >
                            {{ i.name }}
                        </option>
                    </select>
                    <select class="form-control" name="state3" formControlName="topThreeLocationOfInterestInUsaFieldThird" id="topThreeLocationOfInterestInUsaFieldThirdId">
                        <option *ngFor="let i of surveyData?.states" value="{{ i.id }}" >
                            {{ i.name }}
                        </option>
                    </select>
                </div>

            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Top 3 locations of interest (International) </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="form-group location-usa d-md-flex justify-content-between">
                    <select class="form-control" name="country" formControlName="topThreeLocationOfInterestInternationalFieldFirst">
                        <option *ngFor="let i of surveyData?.countries" value="{{ i.id }}" >{{ i.name }}</option>
                    </select>
                    <select class="form-control" name="country1" formControlName="topThreeLocationOfInterestInternationalFieldSecond">
                        <option *ngFor="let i of surveyData?.countries" value="{{ i.id }}" >{{ i.name }}</option>
                    </select>
                    <select class="form-control" name="country2" formControlName="topThreeLocationOfInterestInternationalFieldThird">
                        <option *ngFor="let i of surveyData?.countries" value="{{ i.id }}" >{{ i.name }}</option>
                    </select>
                </div>
            </div>
            <div class="divider-div"></div>
            <h2 class="servey-title">Categories of interest </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.category?.travel">
                    <input type="checkbox" id="{{i._id}}" >
                    <label class="questions" for="{{i._id}}" (click)="thirdSectionCategoriesOfInterest(i._id)" [style.background]="(this.formGroupThird.value.categoriesOfInterest?.includes(i?._id)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupThird.value.categoriesOfInterest?.includes(i?._id)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.name}} </strong>
                    </label>
                </div>
                
                <div class="feature-item">
                    <input class="specify-input" type="text" placeholder="Other please specify" formControlName="thirdSectionCategoriesOfInterestOtherField">
                </div>
            </div>

            <div class="btns-wrap text-center">
                <a (click)="nextQuestionClickedOnThirdQuestionSection()" class="btn">Next Question</a>
            </div>
        </form>
    </div>
    <div class="servey-detail d-flex align-items-center text-center text-md-left d-none" *ngIf="displaySection == 5">
        <form [formGroup]="formGroupFourth">
            <span class="sub-title">Step 4 of 4</span>
            <h2 class="servey-title">Shop well</h2>
            
            
            <h2 class="servey-title">Categories of interest </h2>
            <div class="feature-list d-flex justify-content-between flex-wrap">
                <div class="feature-item" *ngFor="let i of surveyData?.category.shop">
                    <input type="checkbox" id="{{i.id}}" >
                    <label class="questions" for="{{i.id}}" (click)="sectionFourthCategoriesOfInterest(i.id)" [style.background]="(this.formGroupFourth.value.categoriesOfInterest?.includes(i?.id)) ? '#e83d4d' : ''"
                    [style.color]="(this.formGroupFourth.value.categoriesOfInterest?.includes(i?.id)) ? '#fff' : ''">
                        <strong class="text-uppercase">{{i.name}} </strong>
                    </label>
                </div>
                
                <div class="feature-item">
                    <input class="specify-input" type="text" placeholder="Other please specify" formControlName="sectionFourthCategoriesOfInterestOther">
                </div>
                <div class="feature-item d-none d-md-block">&nbsp;</div>
            </div>

            <div class="btns-wrap text-center">
                <a (click)="submitQuestionaire()" class="btn">Submit</a>
            </div>
        </form>
    </div>
</div>
</section>
<div class="enquiry-poup">
    <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
</div>

